import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { LangConstant } from "@/const";
import { PaginationType } from "@/types/common";
import { RowUserType } from "@/types/view";
import { AppScreenTitle, AppTable } from "@/components/common";
import { useUserList } from "@/hooks";
import { MainBodyPage, TableContainer } from "./UserList.style";
import UserActions from "./components/UserActions";
import useUserColumn from "./hooks/useUserColumn";
import { useResetPassword } from "./hooks/useResetPassword";

const UserListPage = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_USER);
  const [pageData, setPageData] = useState<Partial<PaginationType>>({});
  const { columnList } = useUserColumn();
  const { users, pagination } = useUserList(pageData);
  const { resetPassword } = useResetPassword();
  const handleEdit = (_: RowUserType) => {
    // TODO: Go to editing user page
  };

  const handleReset = (row: RowUserType) => {
    resetPassword(row.uid);
  };

  const usersRender = users.map((user: RowUserType) => ({
    ...user,
    handleEdit: () => handleEdit(user),
    handleReset: () => handleReset(user),
  }));

  return (
    <MainBodyPage>
      <Box className="flex-center" sx={{ justifyContent: "space-between" }}>
        <AppScreenTitle>{getLabel("L_USER_TITLE")}</AppScreenTitle>
        <UserActions />
      </Box>
      {/* TODO: Hidden feature in ver0.3 */}
      {/* <UserFilter /> */}

      <TableContainer>
        <AppTable
          data={usersRender}
          columns={columnList}
          pagination={pagination}
          onChangePagination={setPageData}
          hasCheckbox={false}
          onSelectedRequest={() => {}}
        />
      </TableContainer>
    </MainBodyPage>
  );
};
export default UserListPage;
